import { privacyApi } from '../../../api/privacy.js';
import { usePaginatedQuery } from '../../../hooks/usePaginatedQuery.js';
import { DataTable } from '../../../components/DataTable.jsx';
import { Pagination } from '../../../components/ui/Pagination.jsx';
import { PageHeader } from '../../../components/ui/PageHeader.jsx';
import { Select } from '../../../components/ui/Select.jsx';
import { Badge } from '../../../components/ui/Badge.jsx';
import { fmt } from '../../../lib/formatters.js';

const PURPOSES = [
  { value: '', label: 'Tutte' },
  { value: 'tos', label: 'Termini di servizio' },
  { value: 'privacy_policy', label: 'Informativa privacy' },
  { value: 'ai_processing', label: 'Elaborazione AI' },
  { value: 'analytics_tracking', label: 'Analytics' },
  { value: 'marketing_email', label: 'Email marketing' },
  { value: 'product_telemetry', label: 'Telemetria prodotto' }
];

const SCOPES = [
  { value: '', label: 'Tutti' },
  { value: 'platform', label: 'Piattaforma' },
  { value: 'ai', label: 'AI' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'marketing', label: 'Marketing' }
];

const ACTIVE = [
  { value: '', label: 'Tutti' },
  { value: 'true', label: 'Attivi' },
  { value: 'false', label: 'Revocati' }
];

export function ConsentsPage() {
  const { items, isLoading, pagination, page, setPage, filters, setFilters } = usePaginatedQuery({
    key: ['privacy', 'consents'],
    fetcher: privacyApi.listConsents
  });

  const columns = [
    { key: 'subjectId', header: 'Soggetto', render: (r) => <code className="rounded bg-border/40 px-1.5 py-0.5 text-xs">{r.subjectId}</code> },
    { key: 'scope', header: 'Scope', render: (r) => <Badge>{r.scope}</Badge> },
    { key: 'purpose', header: 'Finalità', render: (r) => <span className="text-xs">{r.purpose}</span> },
    { key: 'version', header: 'Vers.', render: (r) => <span className="text-xs text-ink-muted">{r.version || '-'}</span> },
    {
      key: 'state',
      header: 'Stato',
      render: (r) => r.revokedAt
        ? <Badge tone="danger">revocato</Badge>
        : <Badge tone="success">attivo</Badge>
    },
    { key: 'grantedAt', header: 'Concesso', render: (r) => <span className="text-xs text-ink-muted">{fmt.dateTime(r.grantedAt)}</span> },
    { key: 'revokedAt', header: 'Revocato', render: (r) => r.revokedAt ? <span className="text-xs text-ink-muted">{fmt.dateTime(r.revokedAt)}</span> : <span className="text-xs text-ink-faint">-</span> },
    { key: 'ip', header: 'IP', render: (r) => <span className="text-xs text-ink-muted">{r.ip || '-'}</span> }
  ];

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Consensi utenti" description="Audit dei consensi concessi e revocati dai soggetti autenticati." />

      <div className="flex flex-wrap items-end gap-3">
        <Select label="Scope" className="w-44" value={filters.scope || ''} onChange={(e) => setFilters({ scope: e.target.value || undefined })} options={SCOPES} />
        <Select label="Finalità" className="w-56" value={filters.purpose || ''} onChange={(e) => setFilters({ purpose: e.target.value || undefined })} options={PURPOSES} />
        <Select label="Stato" className="w-40" value={filters.active === undefined ? '' : String(filters.active)} onChange={(e) => {
          const v = e.target.value;
          setFilters({ active: v === '' ? undefined : v === 'true' });
        }} options={ACTIVE} />
      </div>

      <DataTable
        columns={columns}
        rows={items}
        loading={isLoading}
        empty={{ title: 'Nessun consenso', description: 'I consensi concessi tramite /me/consents appariranno qui.' }}
      />

      <Pagination pagination={pagination} onPageChange={setPage} />
    </div>
  );
}
